




















































import Vue from 'vue'
import { mapGetters } from 'vuex'
interface Cols {
    cards: Cards[]
}
interface Cards {
    title?: string
    text: string
    buttonText: string
    callback?: Function
}
export default Vue.extend({
    data() {
        return {
            // Enables back button and page title on top of the page
            toolbar: {
                title: 'Message Credit Usage',
                left: [
                    {
                        title: 'Back',
                        icon: 'mdi-chevron-left',
                        back: '/media',
                        tooltip: 'Back',
                        permission: 0
                    }
                ]
            }
        }
    },
    computed: {
        ...mapGetters({
            isApp: 'isApp',
            plan: 'plan',
            meteredRate: 'meteredRate',
            subscription: 'subscription',
            tenant: 'tenant'
        }),
        // Iteritable array to display the elements within each of our cards on the page
        columns(): Cols[] {
            const cols = [
                {
                    cards: [
                        {
                            title: 'refer a friend, get free credits',
                            text: 'Invite your friends or coworkers to use MessageDesk and earn 500 free credits when they sign-up',
                            buttonText: 'Refer a Friend',
                            callback: () => this.goToReferAFriend()
                        },
                        {
                            title: 'leave feedback, get free credits',
                            text: 'Complete our customer satisfaction survey and redeem 500 free credits',
                            buttonText: 'leave feedback',
                            callback: () => this.goToLeaveFeedback()
                        }
                    ]
                },
                {
                    cards: [
                        {
                            text: 'Get 500 free credits when you post a video review of MessageDesk on YouTube, TikTok, Facebook, or Linkedin',
                            buttonText: 'repost video',
                            callback: () => this.goToRepost()
                        }
                    ]
                }
            ]
            return cols
        },
        // Gives us the total number of credits a user is allowed to use before getting metered billing
        totalCredits(): number {
            // If they aren't on a subscription, no credits given
            if (!this.subscription) return 0

            // If they aren't on a plan, no credits given
            if (!this.plan.metadata) return 0

            // Store the user's metadata from their plan
            const meta = this.plan.metadata

            // If they have no message allowance on their plan nor do they have credits on a trial plan, no credits given
            if (!meta.message_allowance && !meta.trial_message_allowance) return 0

            // Otherwise get the amount of credits they're allowed to use from one of their plans, either trialing or payment
            const amt =
                parseInt(meta.message_allowance) || parseInt(meta.trial_message_allowance)

            // Return the amount of credits given or 0 in case of edge case
            return amt || 0
        }
    },
    methods: {
        // Go to the feedback typeform link
        goToLeaveFeedback(): void {
            // Open TypeForm CSAT on new window
            window.open(
                'https://messagedesk.typeform.com/to/v6mzBo77',
                this.isApp ? '_system' : '_blank'
            )
        },
        // Go to repost video typeform link
        goToRepost(): void {
            // Open TypeForm repost video on new window
            window.open(
                'https://messagedesk.typeform.com/to/KjYuiBTT',
                this.isApp ? '_system' : '_blank'
            )
        },
        // Go to refer a friend typeform link
        goToReferAFriend(): void {
            // Open TypeForm friend referral page on new window
            window.open(
                'https://messagedesk.typeform.com/to/qVkzf7Dw',
                this.isApp ? '_system' : '_blank'
            )
        }
    }
})
